import React from "react";
import PropTypes from "prop-types";
import { GetCountryCode } from "root/libs/core-libs/src";
import { Sizes } from "@dhl-official/stencil-library";
import {
  CardPriceHeadline,
  DisclaimerStar,
  ConversionFactorText,
} from "../WCCMultiBUOfferPriceAndPaymentInfo/styled";
import { CardPriceWrapper } from "./styled";
import { formatCurrency } from "../helper";

export default function AccountPriceHeadline({
  intl,
  nativeLanguageCode,
  offer,
  offerIndex,
  showCurrencyIsoCodeForPrices,
  formatCurrencyWithNativeLocale,
}) {
  const countryCode = intl?.locale ? GetCountryCode(intl.locale) : "";
  const priceFormatLocale = formatCurrencyWithNativeLocale
    ? `${nativeLanguageCode}-${countryCode}`
    : intl?.locale || "en-US";

  const offerCurrency = offer?.price?.currencyCode || null;
  const euroCurrency = offer?.euroPrice?.currencyCode || null;
  const euroPrice =
    offer?.euroPrice?.amount > 0
      ? offer.euroPrice.amount
      : offer?.euroPrice?.amount || null;
  const conversionFactor = offer?.price?.currencyConversionFactor;
  const offerPrice = offer?.priceFrequentShipper?.amount;

  const isCurrencyCodeAvailable = !!offerCurrency;

  return (
    <React.Fragment>
      <CardPriceWrapper
        id={`${offer.key}-price`}
        data-testid={`wcc-offer-card-price-wrapper-${offerIndex}`}
        className={euroPrice ? "has-euro-price" : ""}
      >
        <span className="visually-hidden">,</span>
        <CardPriceHeadline
          dataTestid="account-offer-price"
          data-testvalue={offerPrice}
          priority={4}
          weight="700"
          bottomMargin="7px"
        >
          {formatCurrency({
            amount: offerPrice,
            currency: offerCurrency,
            locale: priceFormatLocale,
            showIsoCode: showCurrencyIsoCodeForPrices,
            isCurrencyCodeAvailable,
          })}
          <DisclaimerStar aria-hidden="true"> **</DisclaimerStar>
        </CardPriceHeadline>
        {euroPrice && (
          <React.Fragment>
            <CardPriceHeadline
              dataTestid="offer-euro-price"
              data-testvalue={euroPrice}
              priority={4}
              weight="700"
              bottomMargin="7px"
            >
              {formatCurrency({
                amount: euroPrice,
                currency: euroCurrency,
                locale: priceFormatLocale,
                showIsoCode: showCurrencyIsoCodeForPrices,
                isCurrencyCodeAvailable: !!euroCurrency,
              })}
              <DisclaimerStar aria-hidden="true"> *</DisclaimerStar>
            </CardPriceHeadline>
            {conversionFactor && !Number.isNaN(Number(conversionFactor)) && (
              <ConversionFactorText
                dataTestid="conversion-factor"
                size={Sizes.XS}
                isParagraph
              >
                {`(1 ${euroCurrency} = ${Number(conversionFactor).toFixed(
                  5
                )} ${offerCurrency})`}
              </ConversionFactorText>
            )}
          </React.Fragment>
        )}
      </CardPriceWrapper>
    </React.Fragment>
  );
}

AccountPriceHeadline.propTypes = {
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
  nativeLanguageCode: PropTypes.string.isRequired,
  offer: PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    price: PropTypes.shape({
      currencyCode: PropTypes.string,
      currencyConversionFactor: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    }),
    euroPrice: PropTypes.shape({
      currencyCode: PropTypes.string,
      amount: PropTypes.number,
    }),
    priceFrequentShipper: PropTypes.shape({
      amount: PropTypes.number,
    }),
  }).isRequired,
  offerIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  showCurrencyIsoCodeForPrices: PropTypes.bool.isRequired,
  formatCurrencyWithNativeLocale: PropTypes.bool.isRequired,
};
